/* eslint-disable react/no-did-update-set-state */
import { connect } from 'react-redux';
import { Text, Button } from '@devfolioco/genesis';
import { isValidEmail } from '@devfolioco/helpers';
import CodeInput from 'react-otp-input';
import React from 'react';

import { EMAIL_OTP } from '@constants';
import { verifyEmailOTP, resendEmailOTP } from 'actions/user';

import ResendButton from 'components/Verification/ResendButton';
import { ERRORS } from '@constants/errors';

const OTP_LENGTH = 6;

class Verify extends React.PureComponent {
  static defaultProps = {
    customConfirmationText: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      otp: '',
      error: null,
    };
  }

  componentDidMount() {
    this.sendVerificationCode();
  }

  componentDidUpdate(prevProps) {
    const { emailVerifyStatus } = this.props;

    if (emailVerifyStatus !== prevProps.emailVerifyStatus) {
      if (emailVerifyStatus === EMAIL_OTP.VERIFY_FAILURE) {
        this.setState({ error: EMAIL_OTP.VERIFY_FAILURE });
      } else if (emailVerifyStatus === ERRORS.emailUpdatesBlockedForETHIndia) {
        this.setState({ error: ERRORS.emailUpdatesBlockedForETHIndia });
      }
    }
  }

  sendVerificationCode = () => {
    const { dispatchSendEmailOTP, currentEmail, isEmailVerified } = this.props;
    // Send email OTP if the email is valid and is not verified yet
    if (isValidEmail(currentEmail) && !isEmailVerified) {
      dispatchSendEmailOTP(currentEmail);
    }
  };

  handleOtpChange = otp => this.setState({ otp }, this.autoVerify);

  autoVerify = () => {
    const { error, otp } = this.state;

    if (error) {
      this.setState({ error: null });
    }
    if (otp.length === OTP_LENGTH) {
      // If the received OTP is of required length then automatically
      // verify the email after a small timeout for proper UX
      setTimeout(() => {
        const { currentEmail, dispatchVerifyEmailOTP } = this.props;
        dispatchVerifyEmailOTP(currentEmail, otp);
      }, 400);
    }
  };

  render() {
    const { error, otp } = this.state;
    const { currentEmail, emailVerifyStatus, updateViewState, customConfirmationText, onNotYourEmailClick } =
      this.props;

    const verifying = emailVerifyStatus === EMAIL_OTP.VERIFY_REQUEST;
    const verified = emailVerifyStatus === EMAIL_OTP.VERIFY_SUCCESS;

    return (
      <>
        {customConfirmationText ? (
          <>
            <Text css="max-width: 420px" size={18} weight="semibold" upgrade>
              {customConfirmationText}
            </Text>

            {onNotYourEmailClick && (
              <span>
                <Button
                  type="button"
                  appearance="link"
                  onClick={onNotYourEmailClick}
                  disabled={verifying || verified}
                  style={{ padding: 0 }}
                >
                  Not your email?
                </Button>
              </span>
            )}
          </>
        ) : (
          <>
            <Text css="max-width: 420px" size={18} weight="semibold" upgrade>
              Please enter the six-digit verification code we just sent to {currentEmail}
            </Text>

            <span>
              <Button
                type="button"
                appearance="link"
                onClick={() => updateViewState('EDIT_EMAIL')}
                disabled={verifying || verified}
                style={{ padding: 0 }}
              >
                Not your email?
              </Button>
            </span>
          </>
        )}

        <div css="display: flex; justify-content: center; margin-top: 2em">
          <CodeInput
            value={otp}
            onChange={this.handleOtpChange}
            numInputs={OTP_LENGTH}
            inputStyle={{
              fontSize: 48,
              padding: 8,
              borderRadius: 4,
              border: '2px solid #a6a9ab',
            }}
            renderInput={inputProps => <input {...inputProps} />}
            inputType="tel"
            renderSeparator={<span>&nbsp;&nbsp;</span>}
            shouldAutoFocus
          />
        </div>

        {(error || verifying || verified) && (
          <div css="text-align: center; margin-top: 1em">
            {error && (
              <Text size={18} weight="semibold" color="red-4" upgrade>
                {error === ERRORS.emailUpdatesBlockedForETHIndia
                  ? ERRORS.emailUpdatesBlockedForETHIndia
                  : 'You entered an invalid verification code.'}
              </Text>
            )}

            {verifying && (
              <Text size={18} weight="semibold" color="grey-6" upgrade>
                Verifying ...
              </Text>
            )}

            {verified && (
              <Text size={18} weight="semibold" color="teal-4" upgrade>
                Email verified!
              </Text>
            )}
          </div>
        )}

        <div css="margin-top: 2em">
          <ResendButton email={currentEmail} />
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  emailVerifyStatus: user.emailVerifyStatus,
  error: user.error || '',
  isEmailVerified: user.isEmailVerified,
  saveStatus: user.saveStatus,
});

const mapDispatchToProps = dispatch => ({
  dispatchVerifyEmailOTP: (email, otp) => {
    dispatch(verifyEmailOTP(email, otp));
  },
  dispatchSendEmailOTP: email => {
    dispatch(resendEmailOTP(email));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Verify);
